import { render, staticRenderFns } from "./AuthorizationDialog.vue?vue&type=template&id=1c047f7c&"
import script from "./AuthorizationDialog.vue?vue&type=script&lang=js&"
export * from "./AuthorizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AuthorizationDialog.vue"
export default component.exports